import React from 'react';
import {sprintf} from 'sprintf-js';
import moment from 'moment-timezone';
import styles from './Copyright.scss';
import CustomGrid from '../controls/grid/CustomGrid';
import CustomBox from 'components/controls/grid/CustomBox';

export default function Copyright() {
    return (
        <CustomGrid
            container
            justify="space-between"
        >
            <CustomGrid
                item
            >

                <CustomBox
                    m="xxl-2"
                >
                    <p className={styles.copyrightText}>{sprintf(loc('copyright'), moment().format('YYYY'))}</p>
                </CustomBox>
            </CustomGrid>
            <CustomGrid
                item
            >
                <CustomBox
                    m="xxl-2"
                >
                    <a
                        className={styles.mailTo}
                        href='mailto:cirrusmed@inbox.com'
                    >{loc('our-email')}
                    </a>
                </CustomBox>
            </CustomGrid>
        </CustomGrid>
    );
}



// WEBPACK FOOTER //
// ./src/components/Footer/Copyright.js